import { AnyAction, PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import {
  IBaseReducerActionState,
  IBaseReducerState,
} from "helpers/reduxHelpers";
import {
  IDeliveryOrder,
  IDeliveryOrderDetail,
  IPaginateApiResponse,
} from "model";
import { DeliveryOrderActions } from "redux/actions";

interface IDeliveryState extends IBaseReducerState {
  deliveryOrder?: IPaginateApiResponse<IDeliveryOrder[]>;
  deliveryOrderDetail: IBaseReducerActionState<
    IPaginateApiResponse<IDeliveryOrderDetail[]>
  >;
}

const initialState: IDeliveryState = {
  action: DeliveryOrderActions.prefix,
  prefix: DeliveryOrderActions.prefix,
  deliveryOrderDetail: {
    action: "DELIVERY_ORDER_DETAIL",
  },
};

const getAllDeliveryOrdersSuccess = (
  state: IDeliveryState,
  action: PayloadAction<IPaginateApiResponse<IDeliveryOrder[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.deliveryOrder = action.payload;
  });

const getDeliveryOrderDetailSuccess = (
  state: IDeliveryState,
  action: PayloadAction<IPaginateApiResponse<IDeliveryOrderDetail[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.deliveryOrderDetail.data = action.payload;
    state.deliveryOrderDetail.action = action.type;
  });

const DeliveryReducer = ReduxHelper.createHandleReducer(
  initialState,
  (builder) => {
    builder
      .addCase(
        DeliveryOrderActions.getAllDeliveryOrders.success,
        getAllDeliveryOrdersSuccess
      )

      .addCase(
        DeliveryOrderActions.getDeliveryOrderDetail.success,
        getDeliveryOrderDetailSuccess
      );
  },
  (state: IDeliveryState, action: AnyAction) => {
    const watcherAction = action.type;
    if (watcherAction?.includes("PREPARE_DOCUMENT_DETAIL")) {
      state.deliveryOrderDetail.action = action.type;
    }
  }
);

export default DeliveryReducer;
